import addressCommitTypes from './commit-types';

const INITIAL_ADDRESS_STATE = {
  isAddingAddress: false,
  isEditingAddress: -1,
};

function addressReducers(state = INITIAL_ADDRESS_STATE, action)  {
  if (!action || !action.type) {
    return state;
  }
  switch (action.type) {
    case addressCommitTypes.RESET_ADDRESS_STATE:
      return { ...INITIAL_ADDRESS_STATE };
    case addressCommitTypes.SET_IS_ADDING_ADDRESS:
      return {
        ...state,
        isAddingAddress: action.isAddingAddress,
      };
    case addressCommitTypes.SET_IS_EDITING_ADDRESS:
      return {
        ...state,
        isEditingAddress: action.isEditingAddress,
      };
    default:
      return state;
  }
}

export default addressReducers;
